import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutSmsMessageDetails extends Layout {
    sourceCarrierDriverMessage: DataSource;
    tableSmsMessages: Table;
}
